import { Injectable } from '@angular/core';
import { InternetReviewService } from '../../../services/internet-review.service';

import { ComparableStatus } from '../../_study_constants';
import { InternetReviewMatrixResultView } from '../../../models/internetReviewMatrixResultView';
import _ from 'lodash-es';

@Injectable()
export class InternetReviewSelectionService {
  private rejectedIds: Array<number> = [];

  constructor(private internetReviewService: InternetReviewService) {}

  public syncComparableStatus(comparableId: number, statusId: number): void {
    if (statusId === ComparableStatus.Rejected) {
      this.rejectedIds.push(comparableId);
    } else {
      this.rejectedIds = this.rejectedIds.filter((id) => id != comparableId); // if comparable was again selected as approved or neutral
    }
  }

  public getSelected(): InternetReviewMatrixResultView[] {
    return this.getFilteredComparables();
  }

  public getSelectedCount(): number {
    return this.getFilteredComparables().length;
  }

  private getFilteredComparables(): InternetReviewMatrixResultView[] {
    return this.internetReviewService.getSelectedComparables().filter((s) => !_.includes(this.rejectedIds, s.comparableID));
  }
}
